import http from '@/utils/http';

export default {
	list: data => {
		return http({ url: '/api/admin/v1/guidePrice/list', data }).then(r => r);
	},
	detail: data => {
		return http({ url: '/api/admin/v1/guidePrice/detail', data }).then(r => r);
	},
	create: data => {
		return http({ url: '/api/admin/v1/guidePrice/create', data, tip: true }).then(r => r);
	},
	update: data => {
		return http({ url: '/api/admin/v1/guidePrice/update', data, tip: true }).then(r => r);
	},
	delete: data => {
		return http({ url: '/api/admin/v1/guidePrice/delete', data, tip: true }).then(r => r);
	},
	toggleStatus: data => {
		return http({ url: '/api/admin/v1/guidePrice/toggleStatus', data, tip: true }).then(r => r);
	},
	importPreview: data => {
		return http({ url: '/api/admin/v1/guidePrice/importPreview', data }).then(r => r);
	},
	importCreate: data => {
		return http({ url: '/api/admin/v1/guidePrice/importCreate', data, tip: true }).then(r => r);
	},
	export: data => {
		return http({ url: '/api/admin/v1/guidePrice/export', data }).then(r => r);
	},
};
